"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var selectionSupportedFieldTypes = ['text', 'search', 'url', 'tel', 'password'];
var InputManageCursor = /*#__PURE__*/function (_PureComponent) {
  function InputManageCursor(props) {
    var _this;
    _classCallCheck(this, InputManageCursor);
    _this = _callSuper(this, InputManageCursor, [props]);
    // We need this onKeyUp as a backup to re-enforce cursor position on Android
    _defineProperty(_this, "onKeyUp", function (evt) {
      if (_this.selectionSupported && _this.selectionUpdated) {
        if (_this.Input.input.selectionStart !== _this.newIndex) {
          // console.warn(`--------------------- onKeyUp: selectionStart: ${this.Input.input..selectionStart} selectionStart: ${this.newIndex}`);
          _this.Input.input.setSelectionRange(_this.newIndex, _this.newIndex);
        }
      }
      _this.keyUpCallback(evt);
    });
    _defineProperty(_this, "onKeyDown", function (evt) {
      _this.selectionUpdated = false;
      if (_this.selectionSupported) {
        _this.currIndex = _this.Input.input.selectionStart;
      }
      _this.keyDownCallback(evt);
    });
    _this.currIndex = 0;
    _this.newIndex = 0;
    _this.selectionSupported = selectionSupportedFieldTypes.indexOf(_this.props.type) > -1;
    _this.selectionUpdated = false;
    _this.keyUpCallback = (0, _get["default"])(_this.props, 'extensionProps.onKeyUp', function () {});
    _this.keyDownCallback = (0, _get["default"])(_this.props, 'extensionProps.onKeyDown', function () {});
    return _this;
  }
  _inherits(InputManageCursor, _PureComponent);
  return _createClass(InputManageCursor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // console.warn('componentDidUpdate', this.props, this.selectionSupported);

      if (this.selectionSupported) {
        var value = this.props.value;
        var valueLength = value.length;
        var prevValueLength = (prevProps.value || '').length;
        if (valueLength > prevValueLength) {
          var diff = valueLength - prevValueLength;
          if (diff > 0) {
            diff = this.props.manageCursorHelper(diff, value, this.currIndex);
            this.newIndex = this.currIndex + diff;

            // console.warn(`onUpdate setSelectionRange: ${this.newIndex} diff: ${this.diff}`);
            this.Input.input.setSelectionRange(this.newIndex, this.newIndex);
            this.selectionUpdated = true;
          }
        }
      }
    }
  }, {
    key: "render",
    value:
    /* Placeholder for when we implement copy / paste functionality in Inputs
     onPaste = (evt) => {
     // TODO: Check getData('Text') works on all browsers
     console.warn(`onPaste ${evt.clipboardData.getData('Text')}`);
     this.pasteText = evt.clipboardData.getData('Text');
     }; */

    function render() {
      var _this2 = this;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], _objectSpread(_objectSpread({}, this.props), {}, {
        extensionProps: _objectSpread(_objectSpread({}, this.props.extensionProps), {}, {
          onKeyDown: this.onKeyDown,
          onKeyUp: this.onKeyUp
        }),
        ref: function ref(el) {
          _this2.Input = el;
        },
        "data-jlds": true
      }));
    }
  }]);
}(_react.PureComponent);
_defineProperty(InputManageCursor, "propTypes", _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  manageCursorHelper: _propTypes["default"].func
}));
_defineProperty(InputManageCursor, "defaultProps", _objectSpread(_objectSpread({}, _Input["default"].defaultProps), {}, {
  manageCursorHelper: function manageCursorHelper(diff) {
    return diff;
  }
}));
var _default = exports["default"] = InputManageCursor;